import { ref } from 'vue';

export const showModal = ref(false);
export const currentToolName = ref("");
